module.exports = __webpack_public_path__ + "img/me2.7587891d.png";